import React from 'react';

export default function FormGrid ({ children }) {
    return (
        <div className="form-grid">
            { children }
        </div>
    )
}
